var _path, _circle, _circle2, _circle3, _path2, _circle4, _ellipse, _path3, _path4, _path5, _path6, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoleNotSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 160,
    viewBox: "0 0 168 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.5C8 4.97715 12.4772 0.5 18 0.5H158C163.523 0.5 168 4.97715 168 10.5V22.5H8V10.5Z",
    fill: "#1F418E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 11.5,
    r: 6,
    fill: "#ED7161"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 11.5,
    r: 6,
    fill: "#ECBA16"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 11.5,
    r: 6,
    fill: "#01C859"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22.5H168V128.5C168 139.546 159.046 148.5 148 148.5H28C16.9543 148.5 8 139.546 8 128.5V22.5Z",
    fill: "#D1DEFE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 81.5,
    r: 35,
    fill: "#B2B0B0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.3712,
    cy: 68.586,
    rx: 11.6261,
    ry: 11.2969,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9473 98.9365C66.9473 90.1 74.1107 82.9365 82.9473 82.9365H93.0525C101.889 82.9365 109.053 90.1 109.053 98.9365V102.752C109.053 104.961 107.262 106.752 105.053 106.752H70.9473C68.7381 106.752 66.9473 104.961 66.9473 102.752V98.9365Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4757 137.055C69.2273 137.055 66.1716 137.868 63.4927 139.285C58.268 132.155 49.8205 127.5 40.2526 127.5C36.2573 127.5 32.4547 128.309 29 129.773C36.1397 137.773 45.0101 144.207 55.0196 148.5H90C87.0739 141.772 80.3367 137.055 72.4757 137.055Z",
    fill: "#A8CBE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 154.214C83 145.331 75.7097 138.104 66.7492 138.104C64.7385 138.104 62.7527 138.478 60.8457 139.217L60.3783 139.397L60.1089 138.977C55.5645 131.79 47.7556 127.5 39.2208 127.5C30.1442 127.5 21.8246 132.427 17.5138 140.359L17.3018 140.753L16.8591 140.662C15.8994 140.462 14.9274 140.362 13.9693 140.362C6.26722 140.362 0 146.576 0 154.214C0 155.038 0.0866792 158.715 0.225985 159.5H82.7957C82.9164 158.71 83 155.036 83 154.214Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 53L63 104.5L68 109.5L113.5 58L108.5 53Z",
    fill: "white",
    stroke: "#B2B0B0",
    strokeWidth: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 81.5,
    r: 34.5,
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleNotSupport);
export default __webpack_public_path__ + "static/media/role-not-support.bdbba691b958616e58d5a61f7af799c3.svg";
export { ForwardRef as ReactComponent };